import React from "react";
import { METHODOLOGY_PHASES } from "../data/mock";
import { Badge } from "./ui/badge";
import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

export const MethodologySection = () => {
  const { t } = useTranslation();
  return (
    <section className="py-20 lg:py-28 bg-white" id="proceso">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 section-reveal">
          <Badge className="bg-[#F5F1EA] text-[#C8A24D] border-[#E8D5A0] hover:bg-[#F5F1EA] mb-6 py-1.5 px-4 text-xs font-semibold tracking-wide uppercase">
            {t("methodology.badge")}
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-[42px] text-[#0C2340] leading-tight mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
            {t("methodology.title")}
          </h2>
          <p className="text-lg text-[#4A5568] leading-relaxed">
            {t("methodology.subtitle")}
          </p>
        </div>

        {/* Phases Grid */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {METHODOLOGY_PHASES.map((phase, index) => {
            const Icon = phase.icon;
            return (
              <div
                key={phase.phase}
                className="group relative section-reveal"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <div className="bg-white rounded-2xl border border-[#E8E4DC] p-8 hover-lift h-full relative overflow-hidden">
                  {/* Phase number background */}
                  <div className="absolute -top-4 -right-4 text-[120px] font-bold text-[#F5F1EA] leading-none select-none" style={{ fontFamily: "'DM Serif Display', serif" }}>
                    {phase.phase}
                  </div>
                  
                  <div className="relative z-10">
                    {/* Phase indicator */}
                    <div className="flex items-center gap-3 mb-6">
                      <div className="w-12 h-12 rounded-xl bg-[#F5F1EA] flex items-center justify-center group-hover:bg-[#0C2340] transition-colors duration-300">
                        <Icon className="w-6 h-6 text-[#C8A24D] group-hover:text-[#E8D5A0] transition-colors duration-300" />
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-xs font-bold text-[#C8A24D] uppercase tracking-widest">{t("methodology.phaseLabel")}</span>
                        <span className="text-lg font-bold text-[#0C2340]" style={{ fontFamily: "'DM Serif Display', serif" }}>{phase.phase}</span>
                      </div>
                    </div>

                    <h3 className="text-xl text-[#0C2340] mb-3" style={{ fontFamily: "'DM Serif Display', serif" }}>
                      {t(`methodology.phase${parseInt(phase.phase)}Title`)}
                    </h3>
                    <p className="text-[#4A5568] text-sm leading-relaxed mb-6">
                      {t(`methodology.phase${parseInt(phase.phase)}Desc`)}
                    </p>

                    {/* Detail tag */}
                    <div className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#C8A24D] bg-[#F5F1EA] px-3 py-1.5 rounded-full">
                      <ChevronRight className="w-3.5 h-3.5" />
                      {t(`methodology.phase${parseInt(phase.phase)}Detail`)}
                    </div>
                  </div>
                </div>

                {/* Connector arrow for desktop */}
                {index < METHODOLOGY_PHASES.length - 1 && (
                  <div className="hidden md:flex absolute top-1/2 -right-4 lg:-right-4 z-20 -translate-y-1/2">
                    <div className="w-8 h-8 rounded-full bg-[#C8A24D] flex items-center justify-center shadow-lg shadow-[#C8A24D]/20">
                      <ChevronRight className="w-4 h-4 text-[#0C2340]" />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MethodologySection;
